var map = {
	"./StepIntoInnovation_bg.svg": 943,
	"./about_us_header_img.png": 3340,
	"./about_us_imgs.png": 1280,
	"./advance_software_img.png": 4081,
	"./black_man.png": 111,
	"./black_woman.png": 4479,
	"./cutting_edge_hardware_integration_img.png": 4644,
	"./delivery_guy.png": 6203,
	"./home-header-img.png": 2129,
	"./home-header-img.svg": 1440,
	"./home_hero_bg_annim.png": 1876,
	"./imgg.png": 2481,
	"./innovative_technology_img.png": 4455,
	"./international_conectivity_img.png": 6691,
	"./lgistics_hero_section_img.png": 8229,
	"./logistic_body_img.png": 3987,
	"./man_and_woman.png": 6531,
	"./mission_and_vallue_bg.svg": 1618,
	"./our_journey_bg.svg": 2577,
	"./our_journey_img.png": 7942,
	"./our_journey_man.png": 5029,
	"./overview.png": 7546,
	"./personalise_patient_img.png": 8550,
	"./robust_data_collection_tools.png": 9888,
	"./security_and_compliance.png": 61,
	"./telehealth_excellence_img.png": 75,
	"./ticket_excellence_img.png": 2152,
	"./travels_and_tour_hero_section_img.png": 3890,
	"./turbham-logo.gif": 1497,
	"./turbham_travel_hero_section_img.png": 5334,
	"./turbomedics_foundation_hero_section_img.png": 7977,
	"./turbomedics_hero_section_img.png": 7829,
	"./what_we_offer_bg.svg": 2698,
	"./why_choose_us_img1.svg": 502,
	"./why_choose_us_img2.svg": 3065,
	"./why_choose_us_img3.svg": 3625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;